module.exports = __webpack_public_path__ + "img/gurib.e9955c67.png";